export const first = <T>(array: T[]): T | undefined => {
    return array.length > 0 ? array[0] : undefined;
}
export const replaceElementInArray = <T>(array: T[], element: T, index: number): T[] => {
    return [
        ...array.slice(0, index),
        element,
        ...array.slice(index + 1),
    ];
}
export const findIndexById = <T>(array: T[],elementId: any, getId: (arrayElement:T) => any, typeName?:string): number => {
    const index = array.findIndex(arrayElement => getId(arrayElement) === elementId);
    if (index === -1) {
        throw new Error(`${typeName ?? "Element"} with id ${getId(elementId)} not found.`);
    }
    return index;
}


